export interface Theme {
    withRoundedCorners?: boolean;
    withBoxShadow?: boolean;
}

export const themeDefaultValues: Theme = {
    withBoxShadow: false,
    withRoundedCorners: false,
};

export const themeRoundedCornersValues: Theme = {
    withBoxShadow: false,
    withRoundedCorners: true,
};

export const themeModernValues: Theme = {
    withBoxShadow: true,
    withRoundedCorners: true,
};
